import { Component, inject, OnInit } from '@angular/core';
import { ComponentsModule, DialogService, InputOption } from '@mastechnicaegroup/carelinelive-ui';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
    selector: 'app-run-report-dialog',
    imports: [
        ComponentsModule,
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './run-report-dialog.component.html',
    standalone: true,
    styleUrl: './run-report-dialog.component.scss'
})
export class RunReportDialogComponent implements OnInit {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _router = inject(Router);
    private readonly data = inject<{ report?: string } | null>(DIALOG_DATA, { optional: true });

    selectedReport = '';
    startDate = new Date().toISOString().split('T')[0];
    endDate = new Date().toISOString().split('T')[0];

    protected readonly reportOptions: InputOption<string>[] = [
        {
            label: 'Package summary',
            description: 'Displays all packages.',
            value: 'package-summary'
        },
        {
            label: 'Open packages',
            description: 'Displays all currently open packages, including how long each has been open.',
            value: 'open-packages-summary'
        },
        {
            label: 'Package responses',
            description: 'Displays all responses to packages.',
            value: 'package-responses'
        },
        {
            label: 'Received rejected package responses',
            description: 'Displays packages that were offered to providers and subsequently rejected.',
            value: 'received-rejected-package-responses'
        },
        {
            label: 'Sent rejected package responses',
            description: 'All packages that were rejected.',
            value: 'sent-rejected-package-responses'
        },
        {
            label: 'Time taken to allocate packages',
            description: 'Displays all packages that were successfully allocated to a provider, along with the duration they were awaiting allocation.',
            value: 'time-taken-to-allocate-packages'
        },
        {
            label: 'Package handback',
            description: 'Displays all packages that were handed back.',
            value: 'package-handbacks'
        }
    ];

    ngOnInit() {
        const report = this.data?.report;
        if (report) {
            this.selectedReport = report;
        }
    }

    runReport() {
        this._router.navigate(['/reports', this.selectedReport], {
            queryParams: {
                start_date: this.startDate,
                end_date: this.endDate
            },
            queryParamsHandling: 'merge'
        });
    }

    public static show(dialog: DialogService, report?: string) {
        return dialog.openDialog<DialogRef>(RunReportDialogComponent, {
            data: { report }
        });
    }

}
